(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["reyna-filter-drawer"] && !Shopify.designMode) return;
  try {
    class ReynaFilterDrawer {
    constructor() {
      this.panel = document.querySelector('[data-rfd-panel]');
      this.overlay = document.querySelector('[data-rfd-overlay]');
      if (!this.panel || !this.overlay) return;
      this.bind();
    }

    bind() {
      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-rfd-open]')) {
          event.preventDefault();
          this.open();
          return;
        }
        if (event.target.closest('[data-rfd-close]') || event.target === this.overlay) {
          event.preventDefault();
          this.close();
          return;
        }
        const more = event.target.closest('[data-rfd-more]');
        if (more) {
          event.preventDefault();
          more.parentElement.querySelectorAll('[data-rfd-extra]').forEach((el) => el.removeAttribute('hidden'));
          more.remove();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.panel.hasAttribute('data-open')) this.close();
      });
    }

    open() {
      this.overlay.removeAttribute('hidden');
      // next frame so the transition runs from the hidden state
      requestAnimationFrame(() => {
        this.overlay.setAttribute('data-open', '');
        this.panel.setAttribute('data-open', '');
      });
      this.panel.setAttribute('aria-hidden', 'false');
      document.querySelector('[data-rfd-open]')?.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      this.panel.querySelector('[data-rfd-close]')?.focus();
    }

    close() {
      this.overlay.removeAttribute('data-open');
      this.panel.removeAttribute('data-open');
      this.panel.setAttribute('aria-hidden', 'true');
      document.querySelector('[data-rfd-open]')?.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      setTimeout(() => {
        if (!this.panel.hasAttribute('data-open')) this.overlay.setAttribute('hidden', '');
      }, 400);
    }
  }

  new ReynaFilterDrawer();
  } catch(e) { console.error(e); }
})();

})();
